import styled from "styled-components";
import Flex from "common/Boxes/Flex";
import { CSSProperties } from "react";
import { LAYOUT_SWITCH_OPTION_ID } from "testIds";

interface LayoutSwitchProps {
  layoutIcons: [React.JSX.Element, React.JSX.Element];
  selectedLayoutIndex: number;
  onClick: () => void;
  style?: CSSProperties;
  iconBgStyle?: CSSProperties;
}

const LayoutSwitch = ({
  layoutIcons,
  selectedLayoutIndex,
  onClick,
  style,
  iconBgStyle,
}: LayoutSwitchProps) => {
  return (
    <Background style={style}>
      {layoutIcons.map((icon, index) => (
        <IconBg
          key={index}
          data-testid={LAYOUT_SWITCH_OPTION_ID}
          $selected={index === selectedLayoutIndex}
          onClick={onClick}
          style={iconBgStyle}
        >
          <IconWrapper>{icon}</IconWrapper>
        </IconBg>
      ))}
    </Background>
  );
};

export default LayoutSwitch;

const Background = styled(Flex)`
  border-radius: 6px;
  padding: 4px;
  background: ${(p) => p.theme.colors.lightBlue};
  cursor: pointer;
`;
const IconBg = styled.div<{ $selected?: boolean }>`
  border-radius: 6px;
  padding: 5px 7px;
  fill: ${(p) =>
    p.$selected ? p.theme.colors.layoutBgColor : p.theme.colors.primaryBlue};
  color: ${(p) =>
    p.$selected ? p.theme.colors.layoutBgColor : p.theme.colors.primaryBlue};
  background: ${(p) =>
    p.$selected ? p.theme.colors.primaryBlue : "transparent"};
  transition: background-color 0.25s linear;
`;
const IconWrapper = styled(Flex)`
  height: 16px;
`;
